"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldBadgePosition = exports.EmeraldBadgeType = exports.EmeraldBadgeVariant = exports.EmeraldBadgeSize = void 0;
var EmeraldBadgeSize;
(function (EmeraldBadgeSize) {
    EmeraldBadgeSize["LARGE"] = "large";
    EmeraldBadgeSize["MEDIUM"] = "medium";
    EmeraldBadgeSize["SMALL"] = "small";
})(EmeraldBadgeSize || (exports.EmeraldBadgeSize = EmeraldBadgeSize = {}));
var EmeraldBadgeVariant;
(function (EmeraldBadgeVariant) {
    EmeraldBadgeVariant["DOT"] = "dot";
    EmeraldBadgeVariant["NUMBERED"] = "numbered";
    EmeraldBadgeVariant["NUMBER_LARGE"] = "number-large";
})(EmeraldBadgeVariant || (exports.EmeraldBadgeVariant = EmeraldBadgeVariant = {}));
var EmeraldBadgeType;
(function (EmeraldBadgeType) {
    EmeraldBadgeType["DOT"] = "dot";
    EmeraldBadgeType["NUMBERED"] = "numbered";
})(EmeraldBadgeType || (exports.EmeraldBadgeType = EmeraldBadgeType = {}));
var EmeraldBadgePosition;
(function (EmeraldBadgePosition) {
    EmeraldBadgePosition["TOP_RIGHT"] = "top-right";
    EmeraldBadgePosition["TOP_LEFT"] = "top-left";
    EmeraldBadgePosition["BOTTOM_RIGHT"] = "bottom-right";
    EmeraldBadgePosition["BOTTOM_LEFT"] = "bottom-left";
    EmeraldBadgePosition["CUSTOM"] = "custom";
})(EmeraldBadgePosition || (exports.EmeraldBadgePosition = EmeraldBadgePosition = {}));
//# sourceMappingURL=badge.size.js.map